module.exports = __webpack_public_path__ + "img/id.f3c85b21.svg";